'use client';

import { useEffect, type PropsWithChildren } from 'react';
import { usePathname, useSearchParams, useSelectedLayoutSegment } from 'next/navigation';
import { PageAnimation } from '../_ui/components/PageAnimation';
import { getIsShop } from './sales';

export const MainLayoutClient = ({
  children,
  pdp,
  jwtCookiePresent,
}: PropsWithChildren<{ pdp: JSX.Element; jwtCookiePresent: boolean }>) => {
  const pdpSegments = useSelectedLayoutSegment('pdp');
  const isPdpIntercepted = !!pdpSegments;

  const pathname = usePathname();
  const searchParams = useSearchParams();

  // TODO: remove in 1 year, on 2026-10-24, since we have Lax Jwt cookie now for new logins.
  // If there is no jwt cookie, we reload the page so it actually loads products in case it was
  // caused by SameSite=Strict in Jwt.
  useEffect(() => {
    const internalRedirection = searchParams.get('internal_redirection');
    const isShopOrPdp = getIsShop(pathname) || pathname.startsWith('/product');

    const shouldReload =
      isShopOrPdp && !jwtCookiePresent && (!internalRedirection || internalRedirection === 'false');

    if (shouldReload) {
      const redirectUrl = new URL(window.location.href);
      redirectUrl.searchParams.set('internal_redirection', 'true');
      window.location.href = redirectUrl.toString();
    }
  }, []);

  const hasPageAnimation = searchParams.has('animation');

  return (
    <>
      {hasPageAnimation && <PageAnimation />}
      <div style={{ display: isPdpIntercepted ? 'block' : 'none' }}>{pdp}</div>
      <div style={{ display: isPdpIntercepted ? 'none' : 'block' }}>{children}</div>
    </>
  );
};
